import { ClientBuilder, } from "@commercetools/ts-client";
import { createApiBuilderFromCtpClient, } from "@commercetools/platform-sdk";
class CreateApiClient {
    constructor() {
        this.HAS_CTP_CONFIG = Boolean(process.env.REACT_APP_BASE_URL
            && process.env.REACT_APP_OAUTH_URL
            && process.env.REACT_APP_PROJECT_KEY
            && process.env.REACT_APP_ADMIN_CLIENT_ID
            && process.env.REACT_APP_ADMIN_CLIENT_SECRET
            && process.env.REACT_APP_SPA_CLIENT_ID
            && process.env.REACT_APP_SPA_CLIENT_SECRET);
        this.USE_MOCK_DATA = process.env.REACT_APP_USE_MOCK_DATA === "true" || !this.HAS_CTP_CONFIG;
        this.BASE_URI = process.env.REACT_APP_BASE_URL || "";
        this.OAUTH_URI = process.env.REACT_APP_OAUTH_URL || "";
        this.PROJECT_KEY = process.env.REACT_APP_PROJECT_KEY || "";
        this.ADMIN_CREDENTIALS = {
            // ADMIN CLIENT (SCOPE)
            clientId: process.env.REACT_APP_ADMIN_CLIENT_ID || "",
            clientSecret: process.env.REACT_APP_ADMIN_CLIENT_SECRET || "",
        };
        this.SPA_CREDENTIALS = {
            // SPA CLIENT (SCOPE)
            clientId: process.env.REACT_APP_SPA_CLIENT_ID || "",
            clientSecret: process.env.REACT_APP_SPA_CLIENT_SECRET || "",
        };
        if (!this.HAS_CTP_CONFIG && process.env.REACT_APP_USE_MOCK_DATA !== "true") {
            console.warn("Commercetools config is incomplete. Falling back to mock mode.");
        }
        if (this.USE_MOCK_DATA) {
            this.defaultClient = {};
            this.client = {};
            return;
        }
        this.defaultClient = this.buildDefaultClient(true);
    }
    // API ROOT
    getApiRoot(client) {
        return createApiBuilderFromCtpClient(client);
    }
    // DEFAULT CLIENT
    buildDefaultClient(isAdmin) {
        const credentials = isAdmin ? this.ADMIN_CREDENTIALS : this.SPA_CREDENTIALS;
        return new ClientBuilder()
            .defaultClient(this.BASE_URI, credentials, this.OAUTH_URI, this.PROJECT_KEY)
            .build();
    }
    // AUTHORIZED CLIENT (with Password)
    buildClientWithPassword(email, password) {
        const customTokenCache = {
            get: () => {
                const cached = localStorage.getItem("accessToken");
                if (cached) {
                    return JSON.parse(cached);
                }
                return { token: "", expirationTime: 0 };
            },
            set: (cache) => {
                localStorage.setItem("accessToken", JSON.stringify(cache));
            },
        };
        const options = {
            host: this.OAUTH_URI,
            projectKey: this.PROJECT_KEY,
            credentials: {
                clientId: this.ADMIN_CREDENTIALS.clientId,
                clientSecret: this.ADMIN_CREDENTIALS.clientSecret,
                user: {
                    username: email,
                    password: password,
                },
            },
            scopes: [`manage_project:${this.PROJECT_KEY}`],
            tokenCache: customTokenCache,
            httpClient: fetch,
        };
        return new ClientBuilder()
            .withPasswordFlow(options)
            .withHttpMiddleware({
            host: this.BASE_URI,
        })
            .build();
    }
    // AUTHORIZED CLIENT (with Token)
    buildClientWithToken(token) {
        const authorization = `Bearer ${token}`;
        const options = {
            force: true,
        };
        return new ClientBuilder()
            .withExistingTokenFlow(authorization, options)
            .withHttpMiddleware({
            host: this.BASE_URI,
        })
            .build();
    }
    getOrCreateAnonymousId() {
        const key = "anonymous_id";
        let id = localStorage.getItem(key);
        if (!id) {
            id =
                typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
                    ? crypto.randomUUID()
                    : `anon-${Date.now()}-${Math.random().toString(16).slice(2)}`;
            localStorage.setItem(key, id);
        }
        return id;
    }
}
export default CreateApiClient;
